import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { ChevronRight, ChevronLeft, Menu as MenuIcon } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Menu definitions: top-level MENU and its submenus
const subMenus = {};

const Sidebar = ({ open }) => {
  const [activeSub, setActiveSub] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();

  const menu = [
    { key: "dashboard", label: "Dashboard", to: "/" },
    { key: "company", label: "Company Tax Computation", to: "/company" },
    { key: "cp204", label: "CP204 Compliance", to: "/cp204" },
    ...(user?.role === "admin" ? [{ key: "users", label: "User Maintenance", to: "/users" }] : []),
    ...((user?.email || "").toLowerCase() === "ngkc93@gmail.com" ? [{ key: "tokens", label: "Access Tokens", to: "/tokens" }] : []),
    { key: "logout", label: "Log Out" },
  ];

  const handleMain = (item) => {
    if (item.key === "logout") {
      logout();
      navigate("/login");
      return;
    }
    if (item.hasSub) {
      setActiveSub(item.key);
    } else if (item.to) {
      navigate(item.to);
    }
  };

  const sub = activeSub ? subMenus[activeSub] : null;

  return (
    <aside
      className={`bg-white border-r border-gray-200 shadow-sm transition-all duration-200 overflow-hidden ${
        open ? "w-64" : "w-0"
      }`}
    >
      <div className="w-64">
        {/* header */}
        <div className="bg-[#1877c9] text-white font-semibold text-lg px-5 py-4 tracking-wide">
          {sub ? sub.title : "MENU"}
        </div>

        {!sub ? (
          <nav className="py-1">
            {menu.map((item) => {
              const active =
                (item.to === "/" && location.pathname === "/") ||
                (item.to && item.to !== "/" && location.pathname.startsWith(item.to));
              return (
                <button
                  key={item.key}
                  onClick={() => handleMain(item)}
                  className={`w-full flex items-center justify-between px-5 py-3 text-[15px] text-gray-700 hover:bg-[#eef4fb] transition-colors border-b border-gray-100 ${
                    active ? "bg-[#eef4fb] text-[#1877c9] font-medium" : ""
                  }`}
                >
                  <span>{item.label}</span>
                  {item.hasSub && <ChevronRight size={16} className="text-gray-400" />}
                </button>
              );
            })}
          </nav>
        ) : (
          <nav className="py-1">
            <button
              onClick={() => setActiveSub(null)}
              className="w-full flex items-center gap-2 px-5 py-3 text-[15px] text-gray-700 hover:bg-[#eef4fb] transition-colors border-b border-gray-100"
            >
              <ChevronLeft size={16} className="text-gray-500" />
              <span>Back</span>
            </button>
            {sub.items.map((it, idx) => (
              <button
                key={idx}
                onClick={() => navigate(it.to)}
                className="w-full text-left px-5 py-3 text-[15px] text-gray-700 hover:bg-[#eef4fb] transition-colors border-b border-gray-100"
              >
                {it.label}
              </button>
            ))}
          </nav>
        )}
      </div>
    </aside>
  );
};

const Layout = () => {
  const [open, setOpen] = useState(true);
  return (
    <div className="min-h-screen flex flex-col bg-[#f0f0f0]">
      {/* Top blue bar */}
      <header className="h-14 bg-[#1877c9] flex items-center px-4 shadow-md sticky top-0 z-20">
        <button
          onClick={() => setOpen((o) => !o)}
          className="text-white p-1.5 rounded hover:bg-white/15 transition-colors"
        >
          <MenuIcon size={22} />
        </button>
      </header>
      <div className="flex flex-1">
        <Sidebar open={open} />
        <main className="flex-1 overflow-x-hidden p-6 ibizz-scroll">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
